import { T } from 'react-translator-component';
interface SelectProps {
  value: string;
  label: string;
  id: string;
}

export const parserTenantsForSelect = (tenants: any[]): SelectProps[] | any => {
  return (
    tenants && [
      ...tenants.map((tenant) => ({
        value: tenant.name,
        label: tenant.name || T('Unnamed Account'),
        id: tenant.tenant_pk + tenant.name,
      })),
    ]
  );
};
